import { MassForecastGrid } from '@components/StoreMonitoring/ForecastManagement/components/Grid'
import React from 'react'

export function ForecastManagement() {
  return <MassForecastGrid />
}
